import config from '../shared/configs/app';
import BaseApi from './base';

class BookingInsure extends BaseApi {
    constructor() {
        super(config);
    }
}
export default BookingInsure;